import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { statusBoard } from '../../../content/agencyCopy';
import RevealOnScroll from '../RevealOnScroll';

export default function StatusBoard() {
  return (
    <section
      id="work"
      className="px-6 py-24 md:py-32"
      style={{ background: 'var(--fa-surface)' }}
    >
      <RevealOnScroll className="max-w-[1120px] mx-auto">
        <div className="fa-label mb-4 flex items-center gap-3">
          <span className="fa-status-dot fa-status-dot--live" aria-hidden="true" />
          {statusBoard.label}
        </div>
        <h2
          className="font-display text-[30px] md:text-[40px]"
          style={{ maxWidth: '22ch' }}
        >
          {statusBoard.headline}
        </h2>
        <p
          className="mt-6 text-[16px] md:text-[17px] fa-glow-text"
          style={{ maxWidth: '60ch' }}
        >
          {statusBoard.body}
        </p>

        <div
          className="mt-12"
          style={{
            background: 'var(--fa-paper)',
            border: '1px solid var(--fa-rule)',
          }}
        >
          {/* Header row (desktop only) */}
          <div
            className="hidden md:grid px-6 py-3 fa-label"
            style={{
              gridTemplateColumns: '2fr 0.6fr 1fr 3fr auto',
              gap: '24px',
              borderBottom: '1px solid var(--fa-rule)',
            }}
          >
            <span>Service</span>
            <span>Version</span>
            <span>Status</span>
            <span>Description</span>
            <span className="w-6" />
          </div>

          {statusBoard.rows.map((row, i) => (
            <Link
              key={row.name}
              to={row.href}
              className="group block px-6 py-6 transition-colors"
              style={{
                borderTop: i === 0 ? 'none' : '1px solid var(--fa-rule)',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--fa-signal-wash)')}
              onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
              <div
                className="grid md:items-center gap-y-4 md:gap-x-6"
                style={{ gridTemplateColumns: 'minmax(0, 1fr)' }}
              >
                <div
                  className="md:grid"
                  style={{
                    gridTemplateColumns: '2fr 0.6fr 1fr 3fr auto',
                    gap: '24px',
                    alignItems: 'center',
                  }}
                >
                  <div className="flex items-center gap-3">
                    <span
                      className={`fa-status-dot fa-status-dot--${row.state}`}
                      aria-hidden="true"
                    />
                    <span
                      className="font-display font-bold text-[18px]"
                      style={{ color: 'var(--fa-ink)' }}
                    >
                      {row.name}
                    </span>
                  </div>
                  <div
                    className="fa-mono text-[13px] mt-3 md:mt-0"
                    style={{ color: 'var(--fa-muted)' }}
                  >
                    <span className="md:hidden fa-label mr-2">Version</span>
                    {row.version}
                  </div>
                  <div
                    className="fa-mono text-[12px] mt-2 md:mt-0"
                    style={{
                      color: row.state === 'live' ? 'var(--fa-signal)' : 'var(--fa-muted)',
                      letterSpacing: '0.08em',
                    }}
                  >
                    {row.status}
                  </div>
                  <p className="text-[14px] mt-4 md:mt-0 fa-glow-text">
                    {row.description}
                  </p>
                  <ArrowUpRight
                    size={18}
                    className="hidden md:inline-block transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    style={{ color: 'var(--fa-muted)' }}
                  />
                </div>
                <span
                  className="md:hidden text-[13px] font-medium"
                  style={{ color: 'var(--fa-signal)' }}
                >
                  {row.linkLabel} →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </RevealOnScroll>
    </section>
  );
}
